// extracted by mini-css-extract-plugin
export default {"heading":"HeadingComponent_heading__f97kI"};